// reducers/test-maintenance/index.js

import { combineReducers }        from 'redux';
import { search }                 from './search';
import { searchHasErrored }       from './search';
import { searchIsLoading }        from './search';
import { initiative }             from './initiative';
import { initiativeHasErrored }   from './initiative';
import { initiativeIsLoading }    from './initiative';
import { remove }                 from './remove';
import { removeHasErrored }       from './remove';
import { removeIsLoading }        from './remove';
import { reset }                  from './reset';
import { resetHasErrored }        from './reset';
import { resetIsLoading }         from './reset';
import { add }                    from './untouchables';
import { addHasErrored }          from './untouchables';
import { addIsLoading }           from './untouchables';
import { untouchables }           from './untouchables';
import { untouchablesHasErrored } from './untouchables';
import { untouchablesIsLoading }  from './untouchables';

const searchReducers = combineReducers({
  search,
  searchHasErrored,
  searchIsLoading
});

const initiativeReducers = combineReducers({
  initiative,
  initiativeHasErrored,
  initiativeIsLoading
});

const addReducers = combineReducers({
  add,
  addHasErrored,
  addIsLoading
});

const removeReducers = combineReducers({
  remove,
  removeHasErrored,
  removeIsLoading
});

const resetReducers = combineReducers({
  reset,
  resetHasErrored,
  resetIsLoading
});

const untouchablesReducers = combineReducers({
  untouchables,
  untouchablesHasErrored,
  untouchablesIsLoading
});

export default combineReducers({
  search: searchReducers,
  add: addReducers,
  untouchables: untouchablesReducers,
  remove: removeReducers,
  reset: resetReducers,
  initiative: initiativeReducers
});